import { LogEntry } from './log-entry.model';
import { LogPublisher } from './log-publisher';

export class LogToLocalStorage extends LogPublisher {
    localStorageItemName = 'logs';
    
    override log(entry: LogEntry): void {
        let logs: string[];
        
        try {
            logs = JSON.parse(localStorage.getItem(this.localStorageItemName) as string) || [];
            logs.push(entry.buildLogString());
            localStorage.setItem(this.localStorageItemName, JSON.stringify(logs));
        } catch (ex) {
            console.log(ex);
        }
    }

    override clear(): void {
        localStorage.removeItem(this.localStorageItemName);
    }
}